import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseComponent } from '@shared/components/base-component';

const EXPORT_LIFETIME_IN_MS = 5 * 60 * 1000;

@Component({
  selector: 'app-export-result-modal',
  templateUrl: './export-result-modal.component.html',
  standalone: false,
})
export class ExportResultModalComponent extends BaseComponent implements OnInit {
  protected activeModal = inject(NgbActiveModal);
  private readonly cdr = inject(ChangeDetectorRef);

  data?: { fileUrl?: string };
  exportFailed: boolean = false;
  exportExpired: boolean = false;
  errorMessage: string = '';
  errorDetails: string[] = [];

  ngOnInit() {
    setTimeout(() => {
      if (this.data?.fileUrl) {
        this.exportExpired = true;
        this.cdr.markForCheck();
      }
    }, EXPORT_LIFETIME_IN_MS);
  }
}
